import { PropsWithChildren } from 'react';
import { hashData } from '../01-core/Utilities';
import { ButtonProps } from '../02-atoms/Button';
import { Media, MediaProps } from '../02-atoms/Media';
import { hasMedia } from '../02-atoms/Media.utils';
import { ButtonGroup } from '../03-molecules/ButtonGroup';
import { TabbedContent } from './TabbedContent';

export interface LocationMarkerProps extends PropsWithChildren {
  /** The title */
  title?: string;
  /** The optional tab name */
  tab_name?: string;
  /** The optional address */
  address?: string;
  /** Optional actions */
  actions?: ButtonProps[];
}

export interface LocationProps {
  /** Markers */
  items?: LocationMarkerProps[];
  /** An optional media (e.g. Map) */
  media?: MediaProps;
  /** The current tab */
  current?: number;
  /** On tab change event handler */
  onTabChange?: (tab: number) => void;
}

/** A map having multiple markers */
export const Location = ({
  media,
  current,
  onTabChange,
  ...props
}: LocationProps) => {
  const id = `location-${hashData(props?.items)}`;

  const items = (props?.items || []).map((item, i) => ({
    label: item?.tab_name || item?.title || `Location ${i + 1}`,
    children: (
      <>
        <h3 className="location__title">{item?.title}</h3>
        <div className="location__content">
          {item?.address && <p>{item.address}</p>}
          {item?.children}
          {item.actions && item?.actions?.length > 0 && (
            <ButtonGroup
              className="location__actions"
              type="tertiary"
              items={item.actions}
            />
          )}
        </div>
      </>
    ),
  }));

  return (
    <div id={id} className="location" {...props}>
      <div className="location__wrapper">
        {hasMedia(media) && <Media className="location__map" {...media} />}
        {items?.length > 1 && (
          <TabbedContent
            className="location__tabs"
            items={items}
            current={current}
            onTabChange={onTabChange}
          />
        )}
        {items?.length === 1 && (
          <div className="location__tabs">{items[0].children}</div>
        )}
      </div>
    </div>
  );
};
